export default __webpack_public_path__ + "static/media/puneet.8452e9b0.jpeg";